import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

class PublicPagesNav extends React.Component {
  constructor(props) {
    super(props);
    this.toggleNav = this.toggleNav.bind(this);
    this.closeNav = this.closeNav.bind(this);
    this.state = {
      navExpanded: false
    };
  }

  toggleNav() {
    if (document && document.body && !this.state.navExpanded) {
      const orig = document.body.className;
      document.body.className = `${orig} modal-open`.trim();
    } else if (document && document.body && this.state.navExpanded) {
      document.body.className = document.body.className.replace(/ ?modal-open/g, '');
    }
    this.setState({ navExpanded: !this.state.navExpanded });
  }

  closeNav() {
    if (document && document.body) {
      document.body.className = document.body.className.replace(/ ?modal-open/g, '');
    }
    this.setState({ navExpanded: false });
  }

  render() {
    const { pages, slug } = this.props;
    return (
      <div>
        <div className="visible-sm visible-xs">
          <div className={`nav-control zolaicon-public ${this.state.navExpanded ? 'zolaicon-public-close' : 'zolaicon-public-hamburger-menu'}`} role="button" onClick={this.toggleNav} />
        </div>
        <div className={`pages-nav-container ${this.state.navExpanded ? 'expanded' : ''}`}>
          <div className="nav-container clearfix">
            <ul className="list-inline">
              {pages && pages.filter(page => !page.hidden).map((page, index) => (
                <li key={index}>
                  <Link to={`/wedding/${slug}${page.type !== 'HOME' ? `/${page.type.toLowerCase()}` : ''}`} onClick={this.closeNav} activeClassName="active" onlyActiveOnIndex={page.type === 'HOME'}>
                    {page.nav_title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

PublicPagesNav.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.shape({})),
  slug: PropTypes.string.isRequired
};

export default PublicPagesNav;



/** WEBPACK FOOTER **
 ** ./src/components/PublicWebsite/PublicPagesNav.jsx
 **/